import { styled } from '@mui/material/styles';
import { AppBar, Box, Tab, Theme } from '@mui/material/';

export const StyledAppBar = styled(AppBar)`
  ${({ theme }: { theme: Theme }) => `
  background-color: ${theme.palette.common.white};
  box-shadow: none;

  & .MuiButtonBase-root {
     font-weight: 400;
     color: ${theme.palette.common.black};
  }
  & .Mui-selected {
    background-color: ${theme.palette.common.white};
    font-weight: 700;
    color: ${theme.palette.common.black};
  }
  & .MuiTabs-indicator {
    background-color: ${theme.palette.primary.main};
  }
 `}
`;

export const StyledDivider = styled(Box)`
  ${({ theme }: { theme: Theme }) => `
  border-top: 2px solid ${theme.palette.grey[200]};
  margin-top: -2px;
`}
`;

export const StyledHeaderBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  '&.Mui-focusVisible': {
    backgroundColor: theme.palette.grey[200],
    borderRadius: theme.shape.borderRadius,
  },
}));
